var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"fig fig3"}),_c('div',{staticClass:"fig fig1"}),_c('div',{staticClass:"fig fig2"})])
}]

export { render, staticRenderFns }